import * as React from 'react';

const MlpNetworkingSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg viewBox="0 0 24 24" fill="none" {...props}>
        <path
            d="M30 36l-5.732-6.196M43 26l-5.726 9.838M27.99 22.392L41 23M33 10.466l-7.194 5.289M12.075 13.909L8.86 9.519M6 36.544l5.412-7.024M38 13a6 6 0 100-12 6 6 0 000 12z"
            stroke="#1D0A32"
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            clipRule="evenodd"
            d="M40 41a6 6 0 11-12 0 6 6 0 0112 0zM10 7a3.001 3.001 0 01-6 0 3 3 0 016 0zM7 39a3 3 0 11-6.002-.002A3 3 0 017 38.999zM47 23a3.001 3.001 0 11-6.002-.003A3.001 3.001 0 0147 23zM28 22c0 5.523-4.478 10-10 10S8 27.524 8 22s4.478-10 10-10 10 4.477 10 10z"
            stroke="#1D0A32"
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M21.861 23.049a4 4 0 11-2.854-4.921"
            stroke="#1D0A32"
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

MlpNetworkingSvg.displayName = 'MlpNetworkingSvg';
export default MlpNetworkingSvg;
